export default __webpack_public_path__ + "static/media/word2vec-book.737a3ac3.png";